var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Prop, Component, html } from '@sick-davinci/ce-decorators';
import { style } from './Option.style';
/**
 * Option is a data element for controls that allowed slotted data lile `davinci-drop-down`
 * 
 * @slot {*} content of the option
 */

export let Option = (_dec = Component({
  tag: 'davinci-option',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = (_temp = class Option extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "value", _descriptor, this);

    _initializerDefineProperty(this, "selected", _descriptor2, this);

    _initializerDefineProperty(this, "disabled", _descriptor3, this);
  }

  render() {
    return html`<slot></slot>`;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selected", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
//# sourceMappingURL=Option.js.map